import { c as _c } from "react/compiler-runtime";
import { IcoCheckCircle16, IcoWarning16 } from '@onefootprint/icons';
import titleCase from '../../title-cases';
type BadgeVariant = 'accent' | 'error' | 'info' | 'neutral' | 'success' | 'warning';
type Tag = {
  label: string;
  variant?: BadgeVariant;
};
type TagListProps = {
  title?: string;
  tags: Tag[];
};
const KNOWN_VARIANTS: readonly BadgeVariant[] = ['accent', 'error', 'info', 'neutral', 'success', 'warning'];
const toVariant = (v: string | undefined): BadgeVariant => KNOWN_VARIANTS.includes(v as BadgeVariant) ? v as BadgeVariant : 'neutral';
const TagIcon = t0 => {
  const $ = _c(3);
  const {
    variant
  } = t0;
  if (variant === "error" || variant === "warning") {
    let t1;
    if ($[0] !== variant) {
      t1 = <IcoWarning16 color={variant} className="shrink-0 mt-0.5" />;
      $[0] = variant;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoCheckCircle16 color="primary" className="shrink-0 mt-0.5" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const TagList = t0 => {
  const $ = _c(11);
  const {
    title,
    tags: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const tags = t2;
  let t3;
  if ($[2] !== title) {
    t3 = title && <p className="text-caption-1 text-tertiary fp-text mb-3">{title}</p>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== tags) {
    t4 = tags.map(_temp);
    $[4] = tags;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="flex flex-col gap-1.5">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="w-full">{t3}{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default TagList;
function _temp(t0, i) {
  const {
    label,
    variant
  } = t0;
  return <div key={`${label}-${i}`} className="flex items-start gap-2"><TagIcon variant={toVariant(variant)} /><p className="text-body-2 text-primary fp-text">{titleCase(label)}</p></div>;
}